import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, map } from 'rxjs';
import { DeviceInfoService } from '../../../shared/services/device-info.service';
import { gTDB } from '../../../shared/services/db';
import { SyncClockService } from '../../../shared/services/sync-clock.service';

@Injectable({
  providedIn: 'root',
})
export class CheckpointService {
  cachedCheckpointsListData: any = [];
  cachedCheckpointsListLastRefreshedAt: any;

  constructor(
    private http: HttpClient,
    private deviceInfoService: DeviceInfoService,
    private clockService: SyncClockService,
  ) {}

  async addCheckPoint(requestData: any) {
    const body = {
      ...requestData,
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };

    return lastValueFrom(
      this.http
        .post('/api/check_point/', body)
        .pipe(map((response: any) => response)),
    );
  }

  //Checkpoint APIs

  listCheckpointData(params?: any) {
    return this.http.get(`/api/check_point/`, { params: params });
  }
  async deleteCheckpointById(id: any, body?: any) {
    body = {
      ...body,
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };
    return lastValueFrom(
      this.http
        .post(`/api/check_point/${id}/delete/`, body)
        .pipe(map((response: any) => response)),
    );
  }
  async updateCheckpoint(cpId: string, body: any, params?: any) {
    body = {
      ...body,
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };
    return lastValueFrom(
      this.http
        .put(`/api/check_point/${cpId}/`, body, { params: params })
        .pipe(map((response: any) => response)),
    );
  }
  getRouteById(id: any) {
    return this.http.get(`/api/route/${id}/`).pipe(map((response) => response));
  }
  getCheckPointDetailsById(id: any, params?: any) {
    return this.http
      .get(`/api/check_point/${id}/`, { params: params })
      .pipe(map((response) => response));
  }

  //Route APIs

  addRoute(requestData: any) {
    const body = {
      ...requestData,
    };
    return this.http
      .post('/api/route/', body)
      .pipe(map((response: any) => response));
  }
  getRoutes(params: any) {
    return this.http.get(`/api/route/`, { params: params });
  }
  editRouteById(requestData: any) {
    const body = {
      ...requestData,
    };
    return this.http
      .put(`/api/route/${requestData.id}/`, body)
      .pipe(map((response: any) => response));
  }

  deleteRouteById(id: any) {
    return this.http.delete(`/api/route/${id}`);
  }
  enableDisableRoute(id: any) {
    return this.http.get(`/api/route/${id}/enable_disable_routes/`);
  }

  async updateClient(requestData: any, gps?: any) {
    const body = {
      ...requestData,
      updated_at: requestData?.updated_at || this.clockService.nowMs(),
      device_info: await this.deviceInfoService.getDeviceDetail('must', gps),
    };
    return lastValueFrom(
      this.http
        .post(`/api/patrol/add_update/`, body)
        .pipe(map((response: any) => response)),
    );
  }

  //qr code APIs
  downloadQRCodes(body?: any, params?: any) {
    return this.http
      .post(`/api/check_point/download_qr/`, body, {
        params: params,
      })
      .pipe(map((response: any) => response));
  }
  //missed checkpoints
  missedCheckpoints(body?: any, params?: any) {
    return this.http
      .post(`/api/check_point/missed_checkpoints/`, body, {
        params: params,
      })
      .pipe(map((response: any) => response));
  }
  async getQRCheckpointList() {
    return new Promise(async (resolve) => {
      try {
        let bustCache = true;

        if (this.cachedCheckpointsListLastRefreshedAt) {
          const timeCheck =
            new Date().getTime() - this.cachedCheckpointsListLastRefreshedAt;

          bustCache = timeCheck > 10 * 60 * 1000;
        }

        if (bustCache) {
          const result = await gTDB.cachedData
            .where('shortPath')
            .equals('/api/check_point/list_qr_checkpoints/')
            .first();
          this.cachedCheckpointsListData = result?.data;
          this.cachedCheckpointsListLastRefreshedAt = new Date().getTime();
        }

        resolve(this.cachedCheckpointsListData);
        return;
      } catch (error) {
        resolve([]);
        return;
      }
    });
  }
}
